import { render, staticRenderFns } from "./goods-vip-forever2021.vue?vue&type=template&id=b6e799a8&scoped=true"
import script from "./goods-vip-forever2021.vue?vue&type=script&lang=js"
export * from "./goods-vip-forever2021.vue?vue&type=script&lang=js"
import style0 from "./goods-vip-forever2021.vue?vue&type=style&index=0&id=b6e799a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e799a8",
  null
  
)

export default component.exports